import { useCallback, useEffect } from 'react';
import { Category } from 'api/timesheets/categories';
import { useTranslation } from 'hooks/use-translation';
import { queueMacrotask } from 'utils/macrotask';

export const useEditor = (
  onUpdate: (category: Category) => void,
  editing: Category | null,
  setEditing: (next: Category | null) => void,
) => {
  const cancelEdit = useCallback(() => {
    setEditing(null);
  }, [setEditing]);
  const handleEdit = useCallback(() => {
    const editorText =
      (document.querySelector('#category_name_editor') as HTMLInputElement)
        ?.value ?? '';

    if (editing == null || editorText === '') {
      return;
    }
    onUpdate({
      ...editing,
      name: editorText,
    });
    cancelEdit();
  }, [editing, cancelEdit, onUpdate]);
  const editorTitle = useTranslation(
    'settings.timesheets.controls.categories.edit.title',
  );
  const okText = useTranslation(
    'settings.timesheets.controls.categories.edit.caption',
  );
  const cancelText = useTranslation(
    'settings.timesheets.controls.categories.cancel.caption',
  );

  useEffect(() => {
    if (editing == null) {
      return;
    }
    queueMacrotask(() =>
      (
        document.querySelector('#category_name_editor') as HTMLInputElement
      )?.focus?.(),
    );
  }, [editing]);

  return {
    editorTitle,
    cancelEdit,
    handleEdit,
    okText,
    cancelText,
    id: 'category_name_editor',
  };
};
